// extracted by mini-css-extract-plugin
export default {"capa":"Banner_capa__+tQO8"};